<script>
const SECONDS_TO_AUTO_CONFIRM_CLEARING = 20

export default {
  name: 'AutoConfirmCountdown',
  data: function () {
    return {
      timer: SECONDS_TO_AUTO_CONFIRM_CLEARING
    }
  },
  mounted() {
    window.autoConfirmCountdown = setInterval(() => {
      this.timer > 0 ? this.timer-- : this.finishCountdown()
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(window.autoConfirmCountdown)
  },
  methods: {
    finishCountdown() {
      clearInterval(window.autoConfirmCountdown)
      this.$emit('finishCountdown', 'hello')
    }
  }
}
</script>

<template lang="pug">
div
  h3.mb-0.text-danger.font-italic Automatyczne zatwierdzenie za: {{ timer }}
  .mb-3.text-danger.font-italic Zamknij skrzynkę do tego czasu
</template>
